import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { getEvents, AppEvent } from '../services/eventService';

const Scheduling: React.FC = () => {
  const [events, setEvents] = useState<AppEvent[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      setError(null);
      const rangeStart = moment().startOf('month').subtract(1, 'month').toDate();
      const rangeEnd = moment().endOf('month').add(2, 'month').toDate();
      const eventData = await getEvents(rangeStart, rangeEnd);
      setEvents(eventData);
    } catch (err) {
      console.error('Error fetching events:', err);
      const message = err instanceof Error ? err.message : 'Unable to load scheduling data right now.';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading scheduling...</div>;
  }

  if (error) {
    return <div className="loading">{error}</div>;
  }

  return (
    <div className="scheduling-container">
      <h2>Schedule Events</h2>
      
      <div className="upcoming-events-section">
        <h3>Upcoming Events</h3>
        <div className="events-list">
          {events
            .filter(event => new Date(event.start_time) > new Date())
            .map(event => (
              <div key={event.id} className="event-card">
                <h4>{event.title}</h4>
                <p><strong>Start:</strong> {moment(event.start_time).format('MMMM Do YYYY, h:mm a')}</p>
                <p><strong>End:</strong> {moment(event.end_time).format('MMMM Do YYYY, h:mm a')}</p>
                {event.description && <p>{event.description}</p>}
                {event.location && <p><strong>Location:</strong> {event.location}</p>}
                {event.htmlLink && (
                  <a href={event.htmlLink} target="_blank" rel="noopener noreferrer">
                    View in Google Calendar →
                  </a>
                )}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Scheduling;

